module.exports = __webpack_public_path__ + "img/T1A_rc_17.3ce63214.png";